export function parsePublicFeatureFlag(value: string | undefined): boolean {
  return value?.trim().toLowerCase() === "true";
}

export const publicConfig = {
  apiUrl: process.env.NEXT_PUBLIC_API_URL ?? "https://onix-systems-node-enrollcast-api.dev.onix.team",
  apiTag: process.env.API_TAG ?? "api",
  authHeader: "Authorization",
  nodeEnv: process.env.NODE_ENV,
  appEnv: process.env.APP_ENV,
  shovelsIntegrationEnabled: parsePublicFeatureFlag(process.env.NEXT_PUBLIC_SHOVELS_INTEGRATION_ENABLED),
  devDomain: "https://onix-systems-node-enrollcast-web.dev.onix.team",
  apiDomain: process.env.NEXT_PUBLIC_API_URL ?? "https://onix-systems-node-enrollcast-api.dev.onix.team",
  knowledgeUrl: process.env.NEXT_PUBLIC_KNOWLEDGE_URL ?? "https://onix-systems-node-enrollcast-knowledge.dev.onix.team",
  maptilerApiKey: process.env.NEXT_PUBLIC_MAPTILER_API_KEY,
  boundariesUrl:
    process.env.NEXT_PUBLIC_BOUNDARIES_URL ??
    "https://onix-systems-node-enrollcast-tegola.dev.onix.team/capabilities/districts.json",
  elementaryDistrictsUrl:
    process.env.NEXT_PUBLIC_ELEMENTARY_DISTRICTS_URL ??
    "https://onix-systems-node-enrollcast-tegola.dev.onix.team/capabilities/elementary_districts.json",
  secondaryDistrictsUrl:
    process.env.NEXT_PUBLIC_SECONDARY_DISTRICTS_URL ??
    "https://onix-systems-node-enrollcast-tegola.dev.onix.team/capabilities/secondary_districts.json",
  schoolBoundariesUrl:
    process.env.NEXT_PUBLIC_SCHOOL_BOUNDARIES_URL ??
    "https://onix-systems-node-enrollcast-tegola.dev.onix.team/capabilities/schools.json",
  boundaryPreviewsUrl:
    process.env.NEXT_PUBLIC_BOUNDARY_PREVIEWS_URL ??
    "https://onix-systems-node-enrollcast-tegola.dev.onix.team/capabilities/boundary_previews.json",
  districtBoundaryPreviewsUrl:
    process.env.NEXT_PUBLIC_DISTRICT_BOUNDARY_PREVIEWS_URL ??
    "https://onix-systems-node-enrollcast-tegola.dev.onix.team/capabilities/district_boundary_previews.json",
  customLayersUrl:
    process.env.NEXT_PUBLIC_CUSTOM_LAYERS_URL ??
    "https://onix-systems-node-enrollcast-tegola.dev.onix.team/capabilities/custom_layers.json",
  mapLevelsWorkingUrl:
    process.env.NEXT_PUBLIC_MAP_LEVELS_WORKING_URL ??
    "https://onix-systems-node-enrollcast-tegola.dev.onix.team/capabilities/map_levels_working.json",
  mapLevelsPublishedUrl:
    process.env.NEXT_PUBLIC_MAP_LEVELS_PUBLISHED_URL ??
    "https://onix-systems-node-enrollcast-tegola.dev.onix.team/capabilities/map_levels_published.json",
  newHousingUrl:
    process.env.NEXT_PUBLIC_NEW_HOUSING_URL ??
    "https://onix-systems-node-enrollcast-tegola.dev.onix.team/capabilities/new_housing.json",
} as const;
